import cloneDeep from 'lodash/cloneDeep';
import omit from 'lodash/omit';
import get from 'lodash/get';
import mutations from '@/graphql/mutations';
import { mutate } from '@/plugins/graphql';
import { generateId, isIdGenerated } from '@/utils/id_utils';

export async function uploadImage(url, ownedByOrganization) {
  const input = { url, ownedByOrganization };
  const result = await mutate(mutations.createImage, { input });
  return get(result, 'data.createImage.image.id');
}

export async function saveCoupon(newCoupon, campaignId, isNew) {
  // If campaign is not saved to server yet, so we cant save the coupon,
  // this will be done upon saving the campaign.
  if (isIdGenerated(campaignId)) {
    // return coupon with generated id so coupon wont be "new".
    return { coupon: Object.assign(cloneDeep(newCoupon), { id: generateId() }), errors: [] };
  }

  const omitVars = [
    'images',
    'campaign',
    isNew && 'id',
  ];
  const mutation = isNew ? mutations.createCoupon : mutations.updateCoupon;
  const couponInput = { ...omit(newCoupon, omitVars), campaign: campaignId };

  if (isNew) {
    couponInput.images = newCoupon.images.map(img => img.id).filter(v => !!v);
  }

  const { data, errors } = await mutate(mutation, { couponInput });
  const coupon = get(data, 'createCoupon.coupon') || get(data, 'updateCoupon.coupon');
  return { coupon, errors };
}
